import React from 'react';
import { Form, Icon, Modal, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { requestsActions } from '../../requests.actions';
import useStagesLifeCycleQuery from '../../hooks/useStagesLifeCycleQuery';
import useChangeStageLifeCycle from '../../hooks/useChangeStageLifeCycle';

const StageLifeCycleModalNode = ({ form, onSuccess }) => {
  const { getFieldDecorator, validateFields } = form;

  const dispatch = useDispatch();

  const request = useSelector((state) => state.requestsStore.showModalStage);

  const { data = [], isFetching } = useStagesLifeCycleQuery({
    staleTime: Infinity,
    select: (data) => data?.stagesAddressLifeCycle,
    enabled: Boolean(request),
  });

  const { changeStageLifeCycle, loading } = useChangeStageLifeCycle(onSuccess);

  const handleCancel = () => {
    dispatch(requestsActions.setShowModalStage(null));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    validateFields(async (err, value) => {
      if (!err) {
        await changeStageLifeCycle({
          ids: [request.id],
          value: {
            stageId: value.stageId,
          },
        });

        handleCancel();
      }
    });
  };

  return (
    <Modal
      visible={Boolean(request)}
      onOk={handleSubmit}
      onCancel={handleCancel}
      title="Изменение стадии помещения при создании заявки"
      okText={loading ? <Icon type="loading" /> : 'Изменить'}
      cancelText="Отмена"
      destroyOnClose
    >
      <Form>
        <Form.Item label="Стадия помещения">
          {getFieldDecorator('stageId', {
            rules: [
              {
                required: true,
                type: 'number',
                message: 'Укажите стадию помещения',
              },
            ],
          })(
            <Select
              placeholder="Выберите стадию помещения"
              disabled={isFetching}
              loading={isFetching}
            >
              {data?.map((stage) => (
                <Select.Option
                  key={stage.id}
                  value={stage.id}
                >
                  {stage.name}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

const StageLifeCycleModal = Form.create('form-stage')(StageLifeCycleModalNode);
export default StageLifeCycleModal;
